import { Box } from '@mui/material';
import React from 'react';

import Dialog from '../../../DesignSystem/Dialog';
import Affiliate from './Affiliate';

function AffiliatesModal({ affiliates, open, onClose, title }: any) {
  return (
    <Dialog
      id="affiliates-modal"
      open={open}
      title={title}
      label={title}
      onClose={onClose}
      variant="large"
    >
      {affiliates.map((affiliate: any, index: any, list: any) => (
        <Box
          key={affiliate.slug}
          sx={{
            mb: index === list.length - 1 ? 0 : 1,
          }}
        >
          <Affiliate affiliate={affiliate} />
        </Box>
      ))}
    </Dialog>
  );
}

export default AffiliatesModal;
